module.exports = "/assets/data/65b104c2ccc48500d18f3b9f579cf720-B29.data.json";